
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { IProduct } from '~/interfaces/product';
  import AsyncAction from '~/components/shared/async-action.vue';
  import AppLink from '~/components/shared/app-link.vue';
  import Rating from '~/components/shared/rating.vue';
  import Quickview16Svg from '~/svg/quickview-16.svg';
  import Wishlist16Svg from '~/svg/wishlist-16.svg';
  import Compare16Svg from '~/svg/compare-16.svg';

  export type ProductCardLayout =
    | 'grid-sm'
    | 'grid-nl'
    | 'grid-lg'
    | 'list'
    | 'horizontal';

  @Component({
    components: {
      AsyncAction,
      Quickview16Svg,
      AppLink,
      Rating,
      Wishlist16Svg,
      Compare16Svg,
    },
  })
  export default class ProductCard extends Vue {
    @Prop({ type: Object, required: true }) readonly product!: IProduct | any;
    @Prop({ type: String, default: () => undefined })
    readonly layout!: ProductCardLayout;
    @Prop({ type: Boolean, default: () => false })
    readonly hasDiscount!: ProductCardLayout;
    @Prop({ type: Boolean, default: () => false })
    readonly hasBalance!: ProductCardLayout;
    @Prop({ type: Boolean, default: () => false }) readonly isCatalog: any;

    get features() {
      return this.product?.attributes?.filter((x) => x.featured);
    }

    getImage(data) {
      if (data) {
        //if (data.images) {
        return this.$url.image(
          'products',
          data.id,
          //data.images.data[0].thumbnail
          data.thumbnail
        );
        //}
      }
    }

    productCartLayout() {
      return [
        'product-card',
        'product-card--hidden-actions',
        {
          'product-card--layout--grid product-card--size--sm':
            this.layout === 'grid-sm',
          'product-card--layout--grid product-card--size--nl':
            this.layout === 'grid-nl',
          'product-card--layout--grid product-card--size--lg':
            this.layout === 'grid-lg',
          'product-card--layout--list': this.layout === 'list',
          'product-card--layout--horizontal': this.layout === 'horizontal',
        },
      ];
    }
  }
